"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Default data for the `MaterialTable.localization` attribute
 */
var _default = {
  error: 'Data could not be retrieved',
  grouping: {
    groupedBy: 'Grouped By:',
    placeholder: 'Drag headers here to group by'
  },
  pagination: {
    labelDisplayedRows: '{from}-{to} of {count}',
    labelRowsPerPage: 'Rows per page:',
    labelRowsSelect: 'rows'
  },
  toolbar: {},
  header: {},
  body: {
    filterRow: {},
    editRow: {
      saveTooltip: 'Save',
      cancelTooltip: 'Cancel',
      deleteText: 'Are you sure you want to delete this row?'
    },
    addTooltip: 'Add',
    deleteTooltip: 'Delete',
    editTooltip: 'Edit',
    bulkEditTooltip: 'Edit All',
    bulkEditApprove: 'Save all changes',
    bulkEditCancel: 'Discard all changes'
  }
};
exports["default"] = _default;